import {
    Box,
    Button,
    FormHelperText,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { isNotEmpty } from "../../Utils";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { getLinkUpOTP, iAMSmartLinkUp } from "../../redux/action";
import { getToken } from "../../redux/selector";
import ErrorMsg from "../ErrorMsg/ErrorMsg";
import "../LoginPage/LoginPage.scss";

const useStyles = makeStyles({
    eye: {
        transform: "translate(10px)",
    },
});

export default function LinkUpDialogContent({ openID, onLinkUp }) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const dispatch = useDispatch();

    const { register, handleSubmit, watch, formState, setError } = useForm({
        defaultValues: {
            email: "",
            password: "",
        },
        mode: "onBlur",
    });

    const token = useSelector(getToken());
    const [cookies, setCookie] = useCookies(["token"]);
    useEffect(() => {
        // when login success
        if (isNotEmpty(token)) {
            setCookie("token", token, {
                path: `${Config.CONTENT_PATH}`,
                maxAge: 3600,
                secure: true,
            });
            onLinkUp();
        }
    }, [token]);

    const onFetchError = () => {
        setError("password", {
            type: "invalid",
            message: t(`errorMsg.login.invalid`),
        });
    };

    const [isGenOTP, setIsGenOTP] = useState(false);
    const [otpMsg, setOtpMsg] = useState("");
    const [loginMsg, setLoginMsg] = useState("");
    const [passwordVisible, setPasswordVisible] = useState(false);
    console.log("openID: ", openID);

    const onSubmit = (data, actionType) => {
        console.log("onsubmit", data);
        // let formData = new FormData();
        // formData.append("email", data?.email);
        // formData.append("password", data?.password);
        // formData.append("response", token);
        // Send form value as well as token to the server
        if (actionType === "Login") {
            if (data?.password === "") {
                setLoginMsg("MISSING_PASSWORD");
            } else {
                dispatch(
                    iAMSmartLinkUp(
                        {
                            email: data?.email,
                            otp: data?.password,
                            openID: openID,
                        },
                        onFetchError
                    )
                ).then((result) => {
                    let msg = result?.msg;
                    setLoginMsg(msg);
                });
            }
        } else {
            dispatch(getLinkUpOTP({ email: data?.email }, onFetchError)).then(
                (result) => {
                    let msg = result?.msg;
                    if (msg == "SUCCESS") {
                        setOtpMsg(msg);
                        setIsGenOTP(true);
                    } else {
                        setOtpMsg(msg);
                    }
                }
            );
        }
    };

    const onClickVisible = () => {
        if (passwordVisible) {
            setPasswordVisible(false);
        } else {
            setPasswordVisible(true);
        }
    };

    const errors = formState.errors;

    return (
        <Box width={matches ? 400 : "auto"}>
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    height: "100%",
                }}
            >
                <Typography variant="h5">
                    {t("common.portal.publicLogin")}
                    <br />
                    <br />
                </Typography>
                <CustomTextField
                    label={t("common.email")}
                    required={false}
                    inputProps={register("email", {
                        validate: {
                            valid: (value) =>
                                value.includes("@") || t("errorMsg.email.rule"),
                        },
                        required: t("errorMsg.email.rule"),
                    })}
                    // type="email"
                />
                <FormHelperText>
                    <ErrorMsg message={errors?.email?.message} />
                </FormHelperText>
                {otpMsg != "SUCCESS" && otpMsg != "" && (
                    <FormHelperText>
                        <ErrorMsg
                            message={
                                otpMsg === "NOT_PUBLIC_USER"
                                    ? t("common.portal.notPublicUser")
                                    : otpMsg === "INCORRECT_EMAIL"
                                    ? t("errorMsg.email.rule")
                                    : otpMsg === "ACCOUNT_LOCKED"
                                    ? t("common.login.error.accountLocked")
                                    : null
                            }
                        />
                    </FormHelperText>
                )}
                {isGenOTP && (
                    <CustomTextField
                        label={t("common.portal.password")}
                        required={false}
                        type={passwordVisible ? null : "password"}
                        inputProps={register("password")}
                        unit={
                            passwordVisible === true ? (
                                <Button
                                    onClick={onClickVisible}
                                    disableRipple={true}
                                    className={classes.eye}
                                >
                                    <VisibilityOffIcon
                                        style={{ color: "gray" }}
                                    />
                                </Button>
                            ) : (
                                <Button
                                    onClick={onClickVisible}
                                    disableRipple={true}
                                    className={classes.eye}
                                >
                                    <VisibilityIcon style={{ color: "gray" }} />
                                </Button>
                            )
                        }
                    />
                )}
                {loginMsg != "SUCCESS" && (
                    <FormHelperText>
                        <ErrorMsg
                            message={
                                loginMsg === "invalidEmail"
                                    ? t("common.portal.invalidLogin")
                                    : loginMsg === "incorrectOTP"
                                    ? t("common.portal.missingPw")
                                    : loginMsg === "ACCOUNT_LOCKED"
                                    ? t("common.login.error.accountLocked")
                                    : null
                            }
                        />
                    </FormHelperText>
                )}
                <br />
                <br />
                <Box
                    style={
                        matches
                            ? {}
                            : {
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "column",
                              }
                    }
                >
                    {isGenOTP && (
                        <Button
                            className="buttons"
                            // component={Link}
                            variant="contained"
                            color="primary"
                            //   type="submit"
                            style={
                                matches
                                    ? { marginRight: "20px" }
                                    : {
                                          marginRight: "20px",
                                          marginBottom: "10px",
                                      }
                            }
                            onClick={handleSubmit((data) =>
                                onSubmit(data, "Login")
                            )}
                            data-action="submit"
                            data-callback="onSubmit"
                        >
                            {t("common.sideNavList.login")}
                        </Button>
                    )}
                    <Button
                        className="buttons"
                        variant="contained"
                        color="primary"
                        //  type="submit"
                        onClick={handleSubmit((data) => onSubmit(data, "OTP"))}
                        style={matches ? {} : { marginBottom: "10px" }}
                    >
                        {isGenOTP
                            ? t("common.portal.resendOTP")
                            : t("common.portal.getOTP")}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}
